<ng-template #voorwaarden>
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <!-- prettier-ignore -->
        <span>
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsCaravanInsurance"
                      pdfLinkTitle="Voorwaarden Caravanverzekering">in onze voorwaarden</ins-pdf-link>.</span>
    </p>
</ng-template>

<ng-container *ngIf="coverageId === coverageIdEnum.CaravanAllriskEU || coverageId === coverageIdEnum.CaravanAllriskNL">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <p>Schade aan uw caravan door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Een ongeval bij het rijden</list-flat-item>
                <list-flat-item>Brand, ontploffing of kortsluiting</list-flat-item>
                <list-flat-item>Storm of blikseminslag</list-flat-item>
                <list-flat-item>Overstroming</list-flat-item>
                <list-flat-item>Aardbeving of lawines</list-flat-item>
                <list-flat-item>Vermissing, (poging tot) diefstal of inbraak</list-flat-item>
                <list-flat-item>Botsing met dieren</list-flat-item>
            </list-flat>
            <p>
                Is de schade te repareren? Maar doet u dit niet? Dan betalen wij een deel uit van de kosten die de
                reparatie zou kosten. Dit is afhankelijk van de leeftijd van de caravan. De vergoeding ligt tussen 50%
                (caravan < 12 maanden) en 25% (caravan > 120 maanden).
            </p>
            <p>
                Standaard bent u verzekerd in de Benelux en Duitsland. Neemt u de Europa-optie? Dan bent u ook maximaal
                6 maanden per jaar verzekerd in de rest van Europa, Israël, Marokko en Tunesië.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <p>Schade:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Door verkleuringen, krassen en slijtage</list-flat-item>
                <list-flat-item>Bij normaal (huishoudelijk) gebruik, herstellen of reinigen</list-flat-item>
                <list-flat-item>
                    Door slecht onderhoud (uw caravan heeft elke 2 jaar een deskundige onderhoudsbeurt nodig)
                </list-flat-item>
                <list-flat-item>Door zonlicht, bevriezing, warmte, kou of vocht, sneeuw of sneeuwdruk</list-flat-item>
                <list-flat-item>
                    Door fouten of wijzigingen in de constructie of het frame van de caravan
                </list-flat-item>
                <list-flat-item>Door takelen of slepen</list-flat-item>
                <list-flat-item>Aan alleen de banden</list-flat-item>
                <list-flat-item>
                    Door vermissing, diefstal of inbraak als uw caravan niet is beveiligd met een VbV/SCM goedgekeurd
                    disselslot of wielklem
                </list-flat-item>
                <list-flat-item>
                    Door verhuur, zakelijk gebruik of ander gebruik van de caravan dan recreatie
                </list-flat-item>
                <list-flat-item>Als u permanent in de caravan woont</list-flat-item>
                <list-flat-item>
                    Door opzet of als de bestuurder van de auto die de caravan trekt niet rijbevoegd is
                </list-flat-item>
                <list-flat-item>
                    Als het kenteken niet op uw naam of op naam van een van uw gezinsleden staat
                </list-flat-item>
            </list-flat>

            <p>Hagelschade is niet standaard verzekerd, maar wel aanvullend te verzekeren met onze Hageldekking.</p>

            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <p>Uw eigen risico is: €&nbsp;125</p>
            <p>
                <strong>Let op:</strong>
                Heeft u geen Europadekking bij uw caravanverzekering afgesloten en krijgt u schade buiten de Benelux en
                Duitsland? Dan is uw eigen risico: €&nbsp;1.500.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>
